import * as ACT from '../actions/WarehouseActions';

export function warehouse(state = {}, action) {
    switch (action.type) {


        case ACT.WAREHOUSE_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.WAREHOUSE_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.WAREHOUSE_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.WAREHOUSE_PRODUCT_ITEM:
            return {
                ...state,
                productWarehouse: action.data,
            };
        case ACT.WAREHOUSE_SET_ALL:
            return {
                ...state,
                list: action.data,
            };
        case ACT.WAREHOUSE_CENTRAL_COUNT:
            return {
                ...state,
                centralCount: action.data,
            };
        case ACT.WAREHOUSE_STATE_COUNT:
            return {
                ...state,
                stateCount: action.data,
            };
        case ACT.WAREHOUSE_TECHNICIAN_COUNT:
            return {
                ...state,
                technicianCount: action.data,
            };
        case ACT.WAREHOUSE_TECHNICIAN_STATE_COUNT:
            return {
                ...state,
                technicianStateCount: action.data,
            };


        case ACT.WAREHOUSE_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.WAREHOUSE_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
